import { QarepaEnumInformation } from '@qarepa/common';

export enum TimeBankTypeEnum {
  CLOSE_CALENDAR = 'CLOSE_CALENDAR',
  OTHER = 'OTHER',
  PAID = 'PAID',
}

export const TimeBankTypeArray = Object.values(TimeBankTypeEnum);

export const TimeBankTypeInformation: QarepaEnumInformation<TimeBankTypeEnum> =
  {
    [TimeBankTypeEnum.OTHER]: {
      name: 'Otros',
    },
    [TimeBankTypeEnum.PAID]: {
      name: 'Pagadas',
    },
    [TimeBankTypeEnum.CLOSE_CALENDAR]: {
      name: 'Cierre de mes',
    },
  };
